module.exports = __webpack_public_path__ + "files/b888b98006fa9949ffa983e085cc97d8.png";